/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LogoutAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import ButtonIconMarker from 'DesignSystem/ButtonIconMarker/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaIconLogout from 'DesignSystem/Svgs/TysiaIconLogout/index'
import useIsMedia from 'Simple/hooks/useIsMedia'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function LogoutAction({
  children,
  viewPath = "/App/Account/Content/Menu/LogoutAction",
  isSelected
  
}) {
  let isMedia = useIsMedia()
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtColorsBrandBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.brand.base'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<fromFlow.When is={!isMedia.laptop}>
<ButtonIconMarker
  viewPath={`${viewPath}/ButtonIconMarker`}
 onClick={() => setFlowTo("/App/Auth/SignOut")}
 isSelected={flow.has("/App/Auth/SignOut")}
>
{childProps => (
<TysiaIconLogout
{...childProps}
  viewPath={`${viewPath}/TysiaIconLogout`}
 width={25}
 height={25}
 fill={childProps.isSelected ? dtColorsBrandBase : dtColorsNeutral500}
/>
)}
</ButtonIconMarker>
</fromFlow.When>
<fromFlow.When is={isMedia.laptop}>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 block={true}
 justifyContent="flex-start"
 onClick={() => setFlowTo("/App/Auth/SignOut")}
 isSelected={flow.has("/App/Auth/SignOut")}
 marginTop={dtSpaceXs}
 marginBottom="auto"
>
{childProps => (
<React.Fragment>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconLogout
{...childProps}
  viewPath={`${viewPath}/TysiaIconLogout`}
/>
)}
</TysiaButtonIcon>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 marginLeft={dtSpaceXxs}
 text="Logout"
/>
</React.Fragment>
)}
</TysiaButton>
</fromFlow.When>
{children}
</React.Fragment>)
}